import ProductoDelete from './ProductoDelete'
export {ProductoDelete}
export default ProductoDelete
